import {DocumentStorage} from '../office-js/DocumentStorage';
import {LogEvents} from '../../utils/LogEvents';
import {DocumentStorageKeys} from '../office-js/telemetry/DocumentStorageKeys';
import {DurationMeasureType} from '../interfaces/ILogEvent';
import { TranscriptionStorageType } from '../interfaces/IStoredTranscription';

enum Keys {
  StoredTranscription = 'StoredTranscription',
}

export class DocumentStorageWord extends DocumentStorage {

  constructor() {
    super(TranscriptionStorageType.DocumentStorage);
  }

  async WriteTranscribeContentToClient(content: string): Promise<void> {
    await Word.run(async (context) => {
      context.document.properties.customProperties.add(
        Keys.StoredTranscription,
        content,
      );

      if (content !== undefined || content !== "") {
        const range: Word.Range = context.document.body.insertText(" ", Word.InsertLocation.end);
        if (range != null) {
          range.delete();
        }
      }
      await context.sync();
    });
  }

  async DeleteTranscribeContentFromClient(): Promise<void> {
    await Word.run(async (context) => {
      const property: Word.CustomProperty | null =
        await this.GetStoredTranscriptionCustomProperty(context);
      if (property != null) {
        property.delete();

      const range: Word.Range = context.document.body.insertText(" ", Word.InsertLocation.end);
      if (range != null) {
          range.delete();
      }
      await context.sync();
      }
    });
  }

  async GetStoredTranscriptionCustomProperty(context: Word.RequestContext,): Promise<Word.CustomProperty | null> {
    try {
      LogEvents.DocumentStorage.BeginDurationMeasure(
        DurationMeasureType.Normal,
        DocumentStorageKeys.GetStoredTranscriptionCustomPropertyDuration,
      );
      const property: Word.CustomProperty =
        context.document.properties.customProperties.getItem(
          Keys.StoredTranscription,
        );
      property.load('type,value');
      await context.sync();
      LogEvents.DocumentStorage.EndDurationMeasure(
        DocumentStorageKeys.GetStoredTranscriptionCustomPropertyDuration,
      );

      return property;
    } catch (e: any) {
      LogEvents.DocumentStorage.EndDurationMeasure(
        DocumentStorageKeys.GetStoredTranscriptionCustomPropertyDuration,
      );
      if (e.code == 'ItemNotFound') return null;
      throw e;
    }
  }
}
